import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'

type Params = {
  proposalId: string
}

type QuizResponses = {
  quest1: string
  quest2: number
  quest3: number
  quest4: number
}

const loadOrderDirtRoadQuizResponses = (
  params: Params
): Response<QuizResponses> => {
  return axios.get(`/orders/${params.proposalId}/quiz`)
}

export function useLoadOrderDirtRoadQuizResponses(params: Params) {
  return useQuery(
    ['orders', params],
    () => loadOrderDirtRoadQuizResponses(params),
    {
      enabled: !!params.proposalId,
      cacheTime: 0,
      staleTime: 0,
      onError: () =>
        toast.error('Não foi possível carregar o pedido', {
          toastId: 'order'
        })
    }
  )
}
